import { User } from '@/features/users/types/user';
import { getFullName, getInitialsName } from '@/utils/strings';

import { AuthUser } from '../types/auth';

interface CastCurrentUser extends Pick<User, 'id' | 'usersMarkets'> {
    person: Pick<User['person'], 'firstName' | 'lastName'>;
}

export const castCurrentUserToAuthUser = (currentUser: CastCurrentUser): AuthUser => ({
    id: currentUser.id,
    fullName: getFullName(currentUser.person),
    initialsName: getInitialsName(currentUser.person),
    usersMarkets: currentUser.usersMarkets,
});
